/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getMonthByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const getMonthByIdPayloadRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetMonthById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getMonthByIdIdRegExpTwo)]).optional(),
  "payload": zod.union([zod.number(),zod.string().regex(getMonthByIdPayloadRegExpTwo)]).optional()
});

export type GetMonthById = zod.input<typeof GetMonthById>;
export type GetMonthByIdOutput = zod.output<typeof GetMonthById>;
